"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServerApplicationInsightsClient = void 0;
const isServerApplicationInsightsClient = item => 'defaultClient' in item && 'constructor' in item.defaultClient && 'name' in item.defaultClient.constructor &&
// TODO: After applicationisights@3 is introduced this check must be udated
item.defaultClient.constructor.name === 'NodeClient';
exports.isServerApplicationInsightsClient = isServerApplicationInsightsClient;
